import React, { useState, useRef } from "react"
import { Link } from "gatsby"

import * as classes from "../styles/commentForm.module.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faSpinner,
  faCheck,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons"
import { faSquare, faSquareCheck } from "@fortawesome/free-regular-svg-icons"

import HCaptcha from "@hcaptcha/react-hcaptcha"
import ModalWindow from "./modal"

/*メールアドレスのパターン 正規表現*/
let pattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/

const CommentForm = (props) => {
  const [ip, setIp] = useState()

  const [token, setToken] = useState(null)
  const [hcaptchaIsValid, setHcaptchIsValid] = useState(false)

  const [enteredRating, setEnteredRating] = useState("")
  const [enteredTitle, setEnteredTitle] = useState("")
  const [enteredMessage, setEnteredMessage] = useState("")
  const [enteredName, setEnteredName] = useState("")
  const [enteredEmail, setEnteredEmail] = useState("")
  const [checkedAccept, setCheckedAccept] = useState([])
  const [modalIsOpen, setModalIsOpen] = useState(false)

  const [nameIsValid, setNameIsValid] = useState(false)
  const [messageIsValid, setMessageIsValid] = useState(false)

  const [isSubmitting, setIsSubmitting] = useState(false)

  const getIp = async () => {
    const response = await fetch(
      `https://ipgeolocation.abstractapi.com/v1/?api_key=${process.env.GATSBY_IPVAL_TOKEN}`
    )
    const data = await response.json()
    setIp(data.ip_address)
  }

  const onVerify = () => {
    setToken(token)
    setHcaptchIsValid(true)
    getIp()
  }

  const [showNameError, setShowNameError] = useState(false)
  const nameBlurHandler = () => {
    if (!nameIsValid) {
      setShowNameError(true)
    } else {
      setShowNameError(false)
    }
  }

  const [showMessageError, setShowMessageError] = useState(false)
  const messageBlurHandler = () => {
    if (!messageIsValid) {
      setShowMessageError(true)
    } else {
      setShowMessageError(false)
    }
  }

  const [showEmailError, setShowEmailError] = useState(false)

  const emailRef = useRef()
  const [emailIsValid, setEmailIsValid] = useState(null)
  const [emailChecking, setEmailChecking] = useState(false)

  const emailCheckHandler = async () => {
    if (pattern.test(emailRef.current.value)) {
      setEmailChecking(true)

      const response = await fetch(
        `https://api.hunter.io/v2/email-verifier?email=${emailRef.current.value}&api_key=${process.env.GATSBY_EMAILVAL_TOKEN}`
      )

      if (!response.ok) {
        throw new Error("Email validation failed.")
      }

      const data = await response.json()

      if (data.data.status === "valid") {
        setEmailIsValid(true)
      } else {
        setEmailIsValid(false)
        setShowEmailError(true)
      }

      setEmailChecking(false)
    }
  }

  const ratingChangeHandler = (event) => {
    setEnteredRating(event.target.value)
  }
  const titleChangeHandler = (event) => {
    setEnteredTitle(event.target.value)
  }
  const messageChangeHandler = (event) => {
    setEnteredMessage(event.target.value)
    if (event.target.value.length > 99) {
      setMessageIsValid(true)
      setShowMessageError(false)
    } else {
      setMessageIsValid(false)
    }
  }
  const nameChangeHandler = (event) => {
    setEnteredName(event.target.value)
    if (event.target.value.trim().length > 1) {
      setNameIsValid(true)
      setShowNameError(false)
    } else {
      setNameIsValid(false)
    }
  }
  const emailChangeHandler = (event) => {
    setEnteredEmail(event.target.value)
    setShowEmailError(false)
  }
  const acceptChangeHandler = (event) => {
    setCheckedAccept([event.target.value])
  }

  const enableSubmit =
    messageIsValid &&
    nameIsValid &&
    emailIsValid &&
    checkedAccept.includes("confirmed") &&
    hcaptchaIsValid &&
    ip &&
    !isSubmitting

  const submitHandler = async (event) => {
    event.preventDefault()
    setIsSubmitting(true)

    const dbUrl = `https://comments-a2267-default-rtdb.asia-southeast1.firebasedatabase.app/comments.json?auth=${process.env.GATSBY_FIREBASE_TOKEN}`

    const response = await fetch(dbUrl, {
      method: "POST",
      body: JSON.stringify({
        slug: props.slug,
        name: enteredName,
        email: enteredEmail,
        ip: ip,
        rating: Number(enteredRating),
        title: enteredTitle,
        message: `<p>${enteredMessage
          .replaceAll("\n\n", "</p><p>")
          .replaceAll("\n", "<br />")}</p>`,
        date: new Date().toISOString(),
        approved: false,
      }),
    })

    if (!response.ok) {
      return
    }

    setIsSubmitting(false)
    setEnteredRating("")
    setEnteredTitle("")
    setEnteredMessage("")
    setEnteredName("")
    setEnteredEmail("")
    setCheckedAccept([])
    setHcaptchIsValid(false)
    setToken(null)
    setModalIsOpen(true)
    setEmailIsValid(false)
    setNameIsValid(false)
    setMessageIsValid(false)
  }

  const closeModalHandler = () => {
    setModalIsOpen(false)
  }

  return (
    <>
      <form id="commentform" className={classes.form} onSubmit={submitHandler}>
        <div className="smb-information__body">
          <div className="smb-information__item">
            <label className="c-row">
              <div className="c-row__col c-row__col--1-1 c-row__col--lg-1-5">
                <div className="smb-information__item__label">
                  満足度
                  <span className="badge bg-danger" aria-hidden="true">
                    必須
                  </span>
                </div>
              </div>
              <div className="c-row__col c-row__col--1-1 c-row__col--lg-4-5">
                <fieldset id="rating">
                  <span className={classes.rating}>
                    <input
                      type="radio"
                      id="p-rating_5"
                      name="rating"
                      defaultValue={5}
                      onChange={ratingChangeHandler}
                      checked={enteredRating === "5"}
                      required
                    />
                    <label htmlFor="p-rating_5">5</label>
                    <input
                      type="radio"
                      id="p-rating_4"
                      name="rating"
                      defaultValue={4}
                      onChange={ratingChangeHandler}
                      checked={enteredRating === "4"}
                    />
                    <label htmlFor="p-rating_4">4</label>
                    <input
                      type="radio"
                      id="p-rating_3"
                      name="rating"
                      defaultValue={3}
                      onChange={ratingChangeHandler}
                      checked={enteredRating === "3"}
                    />
                    <label htmlFor="p-rating_3">3</label>
                    <input
                      type="radio"
                      id="p-rating_2"
                      name="rating"
                      defaultValue={2}
                      onChange={ratingChangeHandler}
                      checked={enteredRating === "2"}
                    />
                    <label htmlFor="p-rating_2">2</label>
                    <input
                      type="radio"
                      id="p-rating_1"
                      name="rating"
                      defaultValue={1}
                      onChange={ratingChangeHandler}
                      checked={enteredRating === "1"}
                    />
                    <label htmlFor="p-rating_1">1</label>
                  </span>
                </fieldset>
                {enteredRating && (
                  <span className={`${classes.ratingText} small text-gray`}>
                    ★{enteredRating} {enteredRating === "1" && "不満しかない"}
                    {enteredRating === "2" && "うーん、次は別のお店かな"}
                    {enteredRating === "3" && "可もなく不可もなく"}
                    {enteredRating === "4" && "まずます。友達にオススメできる"}
                    {enteredRating === "5" && "満足！リピート確実"}
                  </span>
                )}
              </div>
            </label>
          </div>
          <div className="smb-information__item">
            <label htmlFor="title" className="c-row">
              <div className="c-row__col c-row__col--1-1 c-row__col--lg-1-5">
                <div className="smb-information__item__label">
                  レビューのタイトル
                </div>
              </div>
              <div className="c-row__col c-row__col--1-1 c-row__col--lg-4-5">
                <input
                  id="title"
                  name="title"
                  type="text"
                  onChange={titleChangeHandler}
                  value={enteredTitle}
                  placeholder="例：プリントが非常に丁寧で良かったです"
                  className={
                    enteredTitle.trim().length > 2 ? classes.valid : ""
                  }
                />
              </div>
            </label>
          </div>
          <div className="smb-information__item">
            <label htmlFor="message" className="c-row">
              <div className="c-row__col c-row__col--1-1 c-row__col--lg-1-5">
                <div className="smb-information__item__label">
                  レビュー本文
                  <span className="badge bg-danger" aria-hidden="true">
                    必須
                  </span>
                </div>
              </div>
              <div className="c-row__col c-row__col--1-1 c-row__col--lg-4-5">
                <textarea
                  id="message"
                  name="message"
                  rows="8"
                  minLength={100}
                  maxLength={1000}
                  required
                  onChange={messageChangeHandler}
                  onBlur={messageBlurHandler}
                  value={enteredMessage}
                  placeholder="例：初めてのオリジナルTシャツの注文で不安でしたが、お店の方が非常に丁寧に対応してくれました。価格は相場より高いかもしれませんが、仕上がりが非常に丁寧で、友人達にも非常に好評です。納期は2週間かかるので、早めの注文をオススメします。"
                  className={`${classes.textarea} ${
                    messageIsValid
                      ? classes.valid
                      : showMessageError
                      ? classes.error
                      : ""
                  }`}
                />
                {showMessageError && (
                  <p className={classes.msgError}>
                    <FontAwesomeIcon icon={faTriangleExclamation} />
                    100文字以上で入力してください。
                  </p>
                )}
                <small className="text-gray">
                  100文字以上・1000文字以下。具体的な内容を伴わない口コミは承認されませんのでご注意下さいませ。
                </small>
              </div>
            </label>
          </div>
          <div className="smb-information__item">
            <label htmlFor="author" className="c-row">
              <div className="c-row__col c-row__col--1-1 c-row__col--lg-1-5">
                <div className="smb-information__item__label">
                  お名前
                  <span className="badge bg-danger" aria-hidden="true">
                    必須
                  </span>
                </div>
              </div>
              <div className="c-row__col c-row__col--1-1 c-row__col--lg-4-5">
                <input
                  id="author"
                  name="name"
                  type="text"
                  required
                  minLength={2}
                  maxLength={10}
                  onChange={nameChangeHandler}
                  onBlur={nameBlurHandler}
                  value={enteredName}
                  autoComplete="name"
                  className={
                    nameIsValid
                      ? classes.valid
                      : showNameError
                      ? classes.error
                      : ""
                  }
                />
                {showNameError && (
                  <p className={classes.msgError}>
                    <FontAwesomeIcon icon={faTriangleExclamation} />
                    2文字以上10文字以下で入力してください。
                  </p>
                )}
              </div>
            </label>
          </div>
          <div className="smb-information__item">
            <label htmlFor="email" className="c-row">
              <div className="c-row__col c-row__col--1-1 c-row__col--lg-1-5">
                <div className="smb-information__item__label">
                  メールアドレス
                  <span className="badge bg-danger" aria-hidden="true">
                    必須
                  </span>
                </div>
              </div>
              <div className="c-row__col c-row__col--1-1 c-row__col--lg-4-5">
                <input
                  id="email"
                  name="email"
                  type="email"
                  required
                  onChange={emailChangeHandler}
                  onBlur={emailCheckHandler}
                  ref={emailRef}
                  value={enteredEmail}
                  autoComplete="email"
                  className={
                    emailIsValid
                      ? classes.valid
                      : showEmailError
                      ? classes.error
                      : ""
                  }
                />
                {emailChecking && (
                  <p className={classes.msg}>
                    <FontAwesomeIcon
                      icon={faSpinner}
                      className="fa-spin text-blue"
                    />{" "}
                    メールアドレスの有効性を確認しています...
                  </p>
                )}
                {showEmailError && (
                  <p className={classes.msgError}>
                    <FontAwesomeIcon icon={faTriangleExclamation} />
                    このメールアドレスでは投稿できません。他のメールアドレスでお試し下さい。
                  </p>
                )}
                {!emailChecking && emailIsValid && (
                  <p className={classes.msg}>
                    <FontAwesomeIcon icon={faCheck} className="text-green" />{" "}
                    このメールアドレスは有効です（投稿可能です）。
                  </p>
                )}
                <small className="text-gray">
                  メールアドレスが公開されることはありません。
                </small>
              </div>
            </label>
          </div>
          <div className="smb-information__item">
            <label htmlFor="accept" className="c-row">
              <div className="c-row__col c-row__col--1-1 c-row__col--lg-1-5">
                <div className="smb-information__item__label">
                  確認事項
                  <span className="badge bg-danger" aria-hidden="true">
                    必須
                  </span>
                </div>
              </div>
              <div
                className="c-row__col c-row__col--1-1 c-row__col--lg-4-5"
                style={{ paddingLeft: "1.5em" }}
              >
                {checkedAccept.includes("confirmed") ? (
                  <FontAwesomeIcon
                    icon={faSquareCheck}
                    className={`${classes.checkIcon} text-green`}
                  />
                ) : (
                  <FontAwesomeIcon
                    icon={faSquare}
                    className={`${classes.checkIcon} text-gray`}
                  />
                )}
                <input
                  type="checkbox"
                  id="accept"
                  name="accept"
                  value="confirmed"
                  onChange={acceptChangeHandler}
                  checked={checkedAccept.includes("confirmed")}
                  className={classes.checkbox}
                  required
                />
                <span className={classes.checkLabel}>
                  <Link to={`/review-guideline/`}>口コミガイドライン</Link>及び
                  <Link to={`/terms-of-service/`}>利用規約</Link>・
                  <Link to={`/privacy-policy/`}>プライバシーポリシー</Link>
                  に同意します
                </span>
              </div>
            </label>
          </div>
        </div>
        <div
          className="smb-buttons is-content-justification-center"
          style={{ margin: "1.5em 0" }}
        >
          <div className="smb-btn-wrapper">
            <HCaptcha
              sitekey={process.env.GATSBY_HCAPTCHA_SITE_KEY}
              onVerify={onVerify}
            />
          </div>
        </div>
        <div
          className="smb-buttons is-content-justification-center"
          style={{ marginTop: "2em" }}
        >
          <button
            className="smb-btn smb-btn__label"
            type="submit"
            disabled={!enableSubmit}
          >
            {isSubmitting ? "口コミを送信中..." : "口コミを投稿する"}
          </button>
        </div>
      </form>
      <ModalWindow isOpen={modalIsOpen} closeModal={closeModalHandler}>
        <div
          style={{
            background: "#fff",
            padding: "3em 1em",
            borderRadius: "5px",
            textAlign: "center",
          }}
        >
          <p>
            レビューが送信されました。
            <br />
            ありがとうございました。
          </p>
        </div>
      </ModalWindow>
    </>
  )
}

export default CommentForm
